import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IRootScopeService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {InnlastingsindikatorKontroller} from "web/moduler/basis/direktiver/innlastingsindikator";
import {FellesAutentiseringsRessurs} from "felles/tjenester/ressurser/FellesAutentiseringsRessurs";

require('./glemt-passord.scss');

export class ØnskerNyttPassordKontroller {
    static regNavn = "nyttPassordKontroller";

    static forInjisering() {
        return [regNavn.ng.ui.$state, regNavn.ng.$rootScope, FellesAutentiseringsRessurs.regNavn, ØnskerNyttPassordKontroller]
    }
    
    constructor(private $state: StateService, 
                private $rootScope: IRootScopeService,
                private fellesAutentiseringsRessurs: FellesAutentiseringsRessurs) {
    }
     
    brukernavn: string;

    lagrer = false;

    nyttPassord() {
        this.lagrer = true;
        this.$rootScope.$emit(InnlastingsindikatorKontroller.vis_innlasting);
        this.fellesAutentiseringsRessurs.ønskerNyttPassord(this.brukernavn).$promise
            .then(respons => {
                this.$state.go("forside.glemt-passord-bekreftelse")
            })
            .finally(() => {
                this.lagrer = false;
                this.$rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig);
            });
    }

    gaaTilbake(){
        this.brukernavn = '';
    }
    
    // private hjelpemetoder

}
